
import device from 'bits/device'
import { Component, Prop, Vue } from 'bits/vue'

@Component({})
export default class OzCheckBox extends Vue {
  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode?: true | false | 'auto'

  /**
   * Direction
   */
  @Prop({ default: 'auto' }) dir!: 'ltr' | 'rtl' | 'auto'

  /**
   * Value of checkbox
   * @default false
   */
  @Prop({ default: false }) value!: boolean

  /**
   * Determines if checkbox is disabled
   * @default false
   */
  @Prop({ default: false }) disabled?: boolean

  /**
   * Label of the checkbox
   */
  @Prop({
    type: String,
    required: false,
    default: '',
  })
  label?: string

  get disabledTextClasses(): Record<string, boolean> {
    return {
      'text-dark-text-400': this.darkMode === false,
      'text-light-text-400': this.darkMode === true,
      'text-dark-text-400 dark:text-light-text-400': this.darkMode === 'auto',
    }
  }

  get disabledSvgClasses(): Record<string, boolean> {
    return {
      'text-modal-overlay-grape': this.darkMode === false,
      'text-modal-overlay-canary': this.darkMode === true,
      'text-modal-overlay-grape dark:text-modal-overlay-canary': this.darkMode === 'auto',
    }
  }

  get isIOS(): boolean {
    return device.ios
  }

  get isMacOSSafari(): boolean {
    return device.mac && device.safari
  }

  // Customize the viewBox value to center the checkbox on macOS Safari, iOS Safari, iOS Chrome, and iOS Firefox.
  get viewBoxForBrowsersOnAppleDevice(): string {
    return this.dir === 'rtl' ? '-0.32 0.3 16 16' : '0.32 0.3 16 16'
  }

  get viewBox(): string {
    return this.isIOS || this.isMacOSSafari ? this.viewBoxForBrowsersOnAppleDevice : '0 0 16 16'
  }

  change(e: Event): void {
    if (this.disabled) return
    this.$emit('input', this.value, e)
  }
}
